<template>
	<div class="addredit">
		<el-form label-width="100px">
			<el-form-item label="收货人" required><el-input placeholder="请输入收货人姓名" v-model="addr_name" type="text" maxlength="20"></el-input></el-form-item>
			<el-form-item label="手机号码" required><el-input placeholder="请输入收货人联系电话" v-model="addr_mobile" type="text" maxlength="20"></el-input></el-form-item>
			<el-form-item label="收货地址" required>
				<el-cascader ref="addr" v-model="selectedOptions" :options="options" style="width: 100%;" placeholder="请选择所在地区" @change="handleChange" />
			</el-form-item>
			<el-form-item label="详细地址" required><el-input placeholder="请输入具体门牌号" v-model="addr_addr" type="text" maxlength="50"></el-input></el-form-item>
			<div class="wd-flex wd-m-l-100">
				<el-button type="primary" class="btn" @click="save" :loading="isloading">保存</el-button>
				<el-button type="info" class="btn" @click="cancleopt">取消</el-button>
			</div>
		</el-form>
	</div>
</template>

<script>
import { regionData, CodeToText, TextToCode} from 'element-china-area-data';
export default {
	name: 'Addredit',
	props: {
		closefun: {
			type: Function,
			default: null
		},
		pid:{
			type: String,
			default:''
		}
	},
	data() {
		return {
			options: regionData,
			selectedOptions: [],
			addr_name:"",
			addr_mobile:"",
			addr_province: "",
			addr_other:"",
			addr_addr:"",
			addr_state:"0",
			isloading: false
		};
	},
	mounted() {
		console.log("mounpid"+this.pid);
		this.loaddata();
	},
	watch:{
		pid:function(){
			console.log("pid"+this.pid);
			this.loaddata();
		}
	},
	methods:{
		loaddata(){
			this.addr_name="";
			this.addr_mobile="";
			this.addr_province= "";
			this.addr_other="";
			this.addr_addr="";
			this.addr_state="0";
			if (this.pid!==""){
				let indata={
					addrid:this.pid
				}
				this.$wd_request("addr",indata,true,".addredit")
				.then(data=>{
					console.log(data);
					this.addr_name=data.value.name;
					this.addr_mobile=data.value.telno;
					this.addr_province=data.value.province;
					this.addr_addr=data.value.addr;
					
					this.addr_state=data.value.state;
					this.addr_other=data.value.other;
					var arr = []
					var txt = data.value.province;
					arr = txt.split('-')
					var code = []
					code[0] = TextToCode[arr[0]].code
					code[1] = TextToCode[arr[0]][arr[1]].code
					code[2] = TextToCode[arr[0]][arr[1]][arr[2]].code
					this.selectedOptions=code;
				})
				.catch(()=>{})
			}
		},
		handleChange(value) {
			console.log(value);
		},
		cancleopt(){
			this.closefun(false);
		},
		save() {
			if (this.selectedOptions == '') {
				this.$wd_toast("请选择所在地区","error");
				return;
			}
			if (this.addr_name==""){
				this.$wd_toast("请输入收货人","error");
				return;
			}
			if (this.addr_mobile==""){
				this.$wd_toast("请输入手机号码","error");
				return;
			}
			if (this.addr_addr==""){
				this.$wd_toast("请输入详细地址","error");
				return;
			}
			
			this.isloading = true;
			var province = CodeToText[this.selectedOptions[0]];
			var city = CodeToText[this.selectedOptions[1]];
			var county = CodeToText[this.selectedOptions[2]];
			var indata={};
			indata.name=this.addr_name;
			indata.mobile=this.addr_mobile;
			indata.province=province+"-"+city+"-"+county;
			indata.addr=this.addr_addr;
			indata.state=this.addr_state;
			indata.other=this.addr_other;
			indata.addrid=this.pid;
			
			this.$wd_request('editaddr', indata,true,".addredit")
				.then(() => {
					this.$wd_toast("保存成功","success");
					this.closefun(true);
				})
				.finally(() => {
					this.isloading = false;
				});
		}
	}
};
</script>

<style lang="scss" scoped>
.btn {
	padding: 15px 40px;
}
</style>
